module.exports = __webpack_public_path__ + "static/media/unsplash.0baa6c2e.png";